import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.293 17.707a1 1 0 0 0 1.414-1.414zM7 7V6a1 1 0 0 0-1 1zM6 17a1 1 0 1 0 2 0zm11-9a1 1 0 1 0 0-2zm.707 8.293-10-10-1.414 1.414 10 10zM8 17V7H6v10zM7 8h10V6H7z"
    />
  </svg>
);
export default SvgArrowUpLeft;
